<template>
  <v-dialog v-model="show" scrollable width="50%" persistent>
    <v-card>
      <Toolbar
        :title="showEdit ? 'Súly módosítása': 'Súly létrehozása'"
        :btn-title="showEdit ?'Módosítás': 'Létrehozás'"
        @btnClicked="showEdit ? updateWeight() : createWeight()"
        @close="reset"
      />

      <v-card-text class="pt-3">
        <v-form>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  label="Kibocsátó"
                  :items="issuers"
                  item-text="name"
                  item-value="id"
                  v-model="weight.issuer_id"
                  clearable
                  :error-messages="getErrorMessage('issuer_id')"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  label="Szabályozók"
                  :items="regulators"
                  item-text="name"
                  item-value="id"
                  v-model="weight.regulator_id"
                  clearable
                  :error-messages="getErrorMessage('regulator_id')"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Súly"
                  v-model="weight.weight"
                  clearable
                  :error-messages="getErrorMessage('weight')"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Toolbar from '../../Modals/Toolbar'

export default {
  name: 'EditWeightModal',
  components:{Toolbar},
  computed: {
    ...mapGetters('Modal', { showEdit: 'showEditModal', showCreate: 'showCreateModal' }),
    ...mapGetters('Weight', ['weight']),
    ...mapGetters('Issuer', ['issuers']),
    ...mapGetters('Regulator', ['regulators']),
    ...mapGetters(['getErrorMessage']),
    show: {
      get () {
        return this.showEdit || this.showCreate
      },
      set (val) {
        this.showEdit = val
        this.showCreate = val
      },
    },
  },
  mounted () {
    this.getAllIssuers();
    this.getAllRegulators();
  },
  methods: {
    ...mapActions('Weight', ['createWeight', 'updateWeight', 'reset']),
    ...mapActions('Issuer', ['getAllIssuers']),
    ...mapActions('Regulator', ['getAllRegulators']),
  },
  watch: {
    showEdit () {
      if (this.showEdit) {
        this.$set(this.weight, 'issuers', this.weight.issuers.map(i => i.id))
        this.$set(this.weight, 'regulators', this.weight.regulators.map(i => i.id))
      }
    },
  },
}
</script>

<style></style>
